import { Injectable } from "@angular/core"
import { AngularFirestoreDocument } from "@angular/fire/firestore"
import { ApiModel, CustomFields } from "@tr/models"
import { getDataItem } from "@tr/utils"
import { DataService } from "./data.service"
import { FirebaseCollectionBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable()
export abstract class UserDefaultsBaseService<DefaultsModel, MainModel extends ApiModel> extends FirebaseCollectionBase<MainModel> {
  public abstract userDefaultsDocName: string
  public customFields: CustomFields
  public customFieldKeys: string[]

  constructor(fb: FirebaseService, protected dataService: DataService) {
    super(fb)
  }

  public async getUserDefaultsDoc(uid: string): Promise<DefaultsModel> {
    const collection = this.userDefaultsCollection(uid)
    const testRunDefaultsSnapshot = collection
      ? await this.userDefaultsCollection(uid)
          .ref
          .get()
      : { exists: false } as any

    return testRunDefaultsSnapshot.exists
      ? testRunDefaultsSnapshot.data() as DefaultsModel
      : null
  }

  public async updateUserDefaultsDoc(
    uid: string,
    defaults: DefaultsModel,
  ): Promise<void> {
    const collection = this.userDefaultsCollection(uid)
    return collection ? await collection.set(defaults) : null
  }

  public userDefaultsCollection(uid: string): AngularFirestoreDocument {
    if (!this.dataService.company.value
        || !this.dataService.project.value
        || !uid
        || !this.userDefaultsDocName) {
      throw new Error("Unable to get user defaults because all required values are not defined")
    }

    return this.firebaseService
      .companyProjectDoc(this.dataService.company.value,this.dataService.project.value)
      .collection("users")
      .doc(uid)
      .collection("defaults")
      .doc(this.userDefaultsDocName)
  }

  public async getDefaultCustomFields(): Promise<void> {
    const company = this.dataService.company.value
    const project = this.dataService.project.value
    const settingsPath = `companies/${company}/projects/${project}/${this.userDefaultsDocName}Settings/customVariables`
    this.customFields = await getDataItem(this.firebaseService.doc(settingsPath), false)
    this.customFieldKeys = Object.keys(this.customFields || {}).sort()
  }

  public updateWithDefaultCustomFields(obj: any): CustomFields {
    (this.customFieldKeys || []).forEach(key => {
      if (obj[key] === undefined) {
        obj[key] = this.customFields[key]
      }
    })

    return obj
  }
}
